import { KeyboardArrowLeft } from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  TextField,
} from "@mui/material";
import React, { useState } from "react";

import { generateAutopilotApiKey } from "services/AutopilotService";

import styles from "../ProfilePage.module.scss";

interface RegenerateApiKeyModalProps {
  open: boolean;
  onClose: () => void;
  userEmail: string;
  onGenerated: (apiKey: string) => void;
  onError: (message: string) => void;
}

const RegenerateApiKeyModal: React.FC<RegenerateApiKeyModalProps> = ({
  open,
  onClose,
  userEmail,
  onGenerated,
  onError,
}) => {
  const [label, setLabel] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    onClose();
    setLabel("");
  };

  const handleGenerate = async () => {
    setLoading(true);
    try {
      const res = await generateAutopilotApiKey(userEmail, label || undefined);
      setLabel("");
      onGenerated(res.api_key);
    } catch {
      onError("Failed to generate API key.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          className: styles.apiKeyModal,
          sx: { minWidth: 480 },
        },
      }}
    >
      <DialogContent className={styles.apiKeyModalContent}>
        <div className={styles.apiKeyModalBack} onClick={handleClose}>
          <KeyboardArrowLeft
            fontSize="small"
            className={styles.apiKeyModalBackArrow}
          />
          <span>Back</span>
        </div>
        <h2 className={styles.apiKeyModalTitle}>Generate Your API Key</h2>
        <p className={styles.apiKeyModalSubtitle}>
          You'll only see this key once. Please copy and store it in a secure
          location.
        </p>
        <TextField
          label="API Key Label (optional)"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          fullWidth
          sx={{
            "& .MuiOutlinedInput-root": {
              color: "white",
              "& fieldset": { borderColor: "#424242" },
              "&:hover fieldset": { borderColor: "#666" },
            },
            "& .MuiInputLabel-root": { color: "#9d9d9d" },
          }}
        />
        <Button
          className={styles.apiKeyModalSubmitBtn}
          disabled={loading}
          onClick={handleGenerate}
        >
          {loading ? (
            <CircularProgress size={18} sx={{ color: "white" }} />
          ) : (
            "Generate API Key →"
          )}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default RegenerateApiKeyModal;
